import { ReactNode } from 'react';
import styles from './infoSection.module.scss';

export const InfoSection = (props: { title: string; information: ReactNode }) => {
  return (
    <main className={`container ${styles['container__title-description']}`}>
      <h1>{props.title}</h1>
      <p>{props.information}</p>
    </main>
  );
};
